@if (needsChoice()) {
  <!--
    role="region" rather than "dialog": a dialog implies the rest of the page is inert, and this one
    deliberately is not. aria-live is absent for the same reason — it appears on load, so announcing
    it would interrupt a screen reader mid-sentence rather than let them reach it in order.
  -->
  <section class="sav-cookie-banner" role="region" aria-label="Cookie choices">
    <div class="sav-cookie-inner">
      <div class="sav-cookie-text">
        <p class="sav-cookie-title">Cookies on SavingArena</p>
        <p>
          We use cookies to see which pages are read and to serve the advertising that keeps this
          site free. Necessary ones always run; the rest are up to you, and you can change your mind
          any time from the footer.
          <a routerLink="/cookie-policy">Read the Cookie Policy</a>.
        </p>
      </div>

      <div class="sav-cookie-actions">
        <button type="button" class="is-quiet" (click)="rejectAll()">Necessary only</button>
        <button type="button" class="is-quiet" (click)="acceptAnalyticsOnly()">Analytics only</button>
        <button type="button" class="is-primary" (click)="acceptAll()">Accept all</button>
      </div>
    </div>
  </section>
}
